var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from '@/components';
import { useConfigContext, useJobDetails } from '@/hoc';
export var JobKeySkills = function () {
    var _a, _b;
    var _c = useJobDetails(), jobDetails = _c.jobDetails, isLoading = _c.isLoading;
    var jobListingPageUrl = useConfigContext().config.jobListingPageUrl;
    return (_jsx(Card, { title: 'Key Skills', children: _jsxs("div", { className: 'flex flex-wrap gap-1', children: [isLoading &&
                    __spreadArray([], Array(3), true).map(function (_, index) { return (_jsx("div", { className: 'px-3 py-1 rounded-full border-2 border-vjwPrimary text-vjwPrimary text-sm hover:bg-blue-50 cursor-pointer', children: _jsx("div", { className: 'animate-pulse w-20 h-5 bg-vjwSecondary rounded-full' }) }, index)); }), !isLoading && !((_a = jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.skill) === null || _a === void 0 ? void 0 : _a.length) && (_jsx("div", { className: 'py-1 text-sm', children: "No skills found" })), (_b = jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.skill) === null || _b === void 0 ? void 0 : _b.map(function (skill) { return (_jsx("div", { onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        window.sessionStorage.setItem('jobFilters', JSON.stringify({
                            appliedFilters: [
                                {
                                    label: skill.skill_name,
                                    value: skill.skill_id,
                                    queryKey: 'skill',
                                },
                            ],
                        }));
                        window.location.href = jobListingPageUrl !== null && jobListingPageUrl !== void 0 ? jobListingPageUrl : '/';
                    }, className: 'px-3 py-1 rounded-full border-2 border-vjwPrimary text-vjwPrimary text-sm hover:bg-blue-50 cursor-pointer', children: skill.skill_name }, skill.skill_id)); })] }) }));
};
